export default __webpack_public_path__ + "static/media/elevate-blk-banner-3.4e679e7e.jpg";